<template>
  <div class="journey">
    <div v-if="beginning" class="name">
      <text-ref v-if="journey.ref" :id="journey.ref" :text="[journey.title]"/>
      <span v-else>{{journey.title}}</span>
    </div>
    <div v-for="element in journey.elements">
      <multi-line v-if="element.class === 'JourneyStageDirection'" :element="element"/>
      <multi-element v-else-if="element.class === 'Stanza'" :element="element"/>
    </div>
  </div>
</template>
<script>
  import MultiLine from './MultiLine'
  import MultiElement from './MultiElement'
  import TextRef from "./TextRef.vue";

  export default {
    components: { TextRef, MultiElement, MultiLine},
    props: {
      journey: {type: Object, required: true}
    },
    computed: {
      beginning() {
        return this.journey.line_index.start === this.journey.elements[0].line_index.start
      }
    }
  }
</script>
<style lang="scss" scoped>
  .journey {
    .name {
      text-align: center;
      font-weight: bold;
    }
  }
</style>
